import { PostModel } from '@pulsex/models';
import { getAssets, getRelatedPosts } from '@pulsex/services';
import { useQuery } from '@tanstack/react-query';
export default function useRelatedPosts({ postId, config, size = 4, fromDate, toDate, enabled = true, searchAssetsUrl, }) {
    var _a, _b, _c, _d;
    const assets = useQuery({
        queryKey: ['GET_ASSETS'],
        queryFn: () => getAssets(config),
        refetchOnWindowFocus: false,
        enabled: !!postId && enabled,
    });
    const query = useQuery({
        queryKey: ['GET_RELATED_POSTS', postId, size, fromDate, toDate],
        queryFn: () => {
            var _a, _b;
            return getRelatedPosts({
                config,
                postId,
                timezoneOffset: (_b = (_a = assets.data) === null || _a === void 0 ? void 0 : _a.timeZone) === null || _b === void 0 ? void 0 : _b.baseUtcOffset,
                fromDate,
                toDate,
                size,
                searchAssetsUrl,
            });
        },
        refetchOnWindowFocus: false,
        enabled: !!postId && !!assets.data && enabled,
    });
    let mappedPosts;
    if (query.isSuccess && ((_b = (_a = query.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length)) {
        const postMapper = new PostModel(config);
        mappedPosts = (_d = (_c = query.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.map((post) => postMapper.mapPost(post));
    }
    return {
        isLoading: query.isLoading,
        posts: mappedPosts,
    };
}
